<h1 class="display">Log in</h1>
<section class="ctx-card">
  <section class="ctx-card__content" #cardContent>
    <form
      [formGroup]="formGroup"
      (ngSubmit)="submit()"
      class="flex flex-col gap-4 py-2 items-stretch justify-center"
    >
      <section class="flex flex-col gap-4">
        <!-- Alert -->
        @if (showApiMessage) {
        <ctx-alert [alertLevel]="apiMessage.alertLevel">{{
          apiMessage.text
        }}</ctx-alert>
        }

        <!-- Account Alias -->
        @if (environment.get('name') === 'local') {
        <mat-form-field>
          <mat-label>Account Alias</mat-label>
          <input matInput type="text" formControlName="accountAlias" />
          <mat-error>{{ getControlError(formGroup, 'email') }}</mat-error>
        </mat-form-field>
        }
        <!-- Email -->
        <mat-form-field>
          <mat-label>Email Address</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            autocomplete="email"
            required
          />
          <mat-error>{{ getControlError(formGroup, 'email') }}</mat-error>
        </mat-form-field>

        <!-- Password -->
        <mat-form-field>
          <mat-label>Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            autocomplete="current-password"
            required
          />
          <mat-error>{{ getControlError(formGroup, 'password') }}</mat-error>
        </mat-form-field>
      </section>

      <button
        ctx-button--primary
        [disabled]="formStates.disabled"
        [loading]="formStates.submit"
        type="submit"
      >
        Log in
      </button>

      <!-- Forgot Password? -->
      <a class="self-end" [routerLink]="['/auth/forgot-password']">
        <span>Forgot password?</span>
        <hlm-icon name="RESET_PASSWORD" class="ml-1" inline></hlm-icon
      ></a>

      <!-- <hr /> -->
      <!-- SSO -->
      <button
        ctx-button--primary
        color="accent"
        actionIcon="SSO"
        (click)="initSsoLogin()"
        type="button"
        [loading]="formStates.sso"
      >
        Continue with SSO
      </button>
      <ctx-google-sso
        [parentForm]="this"
        [cardContent]="cardContent"
      ></ctx-google-sso>
    </form>
  </section>
</section>
